import { Component, Input, OnDestroy } from '@angular/core';
import { LocalizationService } from 'src/app/services/localization.service';
import { Allergens } from 'src/interfaces/enums.model';

/**
 * Иконки аллергенов позиции: на фото карточки — в светлой подложке, в корзине и
 * заказе — строкой (plain). Больше [max] — «+N». Нажатие на иконку — подсказка
 * с названием (названия всегда есть в карточке блюда)
 */
@Component({
    selector: 'app-allergen-pill',
    templateUrl: './menu-allergen-pill.component.html',
    styleUrls: ['./menu-allergen-pill.component.css'],
    standalone: false
})
export class MenuAllergenPillComponent implements OnDestroy {
  @Input() allergens: Allergens[] = [];
  @Input() max: number = 4;
  @Input() size: number = 16;
  @Input() plain: boolean = false;

  /** Подсказка: аллерген или «+N» */
  active: Allergens | 'more' | null = null;
  private timer: ReturnType<typeof setTimeout> | null = null;

  constructor(private localization: LocalizationService) {}

  /** Ровно max иконок — без «+N» */
  get shown(): Allergens[] {
    return this.allergens.length > this.max ? this.allergens.slice(0, this.max - 1) : this.allergens;
  }

  get hidden(): Allergens[] {
    return this.allergens.slice(this.shown.length);
  }

  get hiddenTitles(): string {
    return this.hidden.map((a) => this.localization.getAllergenTranslation(a)).join(', ');
  }

  show(item: Allergens | 'more', event: Event): void {
    // Карточка блюда под иконками не открывается
    event.stopPropagation();
    this.active = this.active === item ? null : item;
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => (this.active = null), 2500);
  }

  ngOnDestroy(): void {
    if (this.timer) clearTimeout(this.timer);
  }
}
